import {
    BlurEvent,
    EditRowDecorator,
    Snackbar,
    Table,
    TableRow,
    TableRowDisplayEvent,
    Textbox
} from "@mcleod/components";
import { AutogenLayoutFreightMatchingControl } from "./autogen/AutogenLayoutFreightMatchingControl";
import { FreightMatchingUser } from "./FreightMatchingUser";
import { FreightMatchingUtil } from "./FreightMatchingUtil";
import { CommonDialogs } from "@mcleod/common";
import {StringUtil} from "@mcleod/core";

export class FreightMatchingControl extends AutogenLayoutFreightMatchingControl {

    onLoad(): void | Promise<void> {
        new FreightMatchingUtil(this);
        this.tableFreightMatchingUsers.onEditLayoutLoaded = (rowDecorator: EditRowDecorator, _tableRow: TableRow) => {
            const trackingEnabled = this.activeRow.get("enable_milestones") === "Y";
            const fmUserLayout = rowDecorator.layout as FreightMatchingUser;
            fmUserLayout.refreshDfmTrackingProviders = () => {
                void this.sourceDfmTrackingProviders.search();
            };
            if (fmUserLayout.textboxDfmProvider) {
                fmUserLayout.textboxDfmProvider.visible = trackingEnabled;
            }
            if (fmUserLayout.checkboxRequireTracking) {
                fmUserLayout.checkboxRequireTracking.visible = trackingEnabled;
            }
        };
        this.tableProfiles.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            if (tableRow === this.tableProfiles.quickAddRow) {
                // Override the showEditLayout method to add validation before opening the slideout
                const originalShowEditLayout = tableRow.showEditLayout.bind(tableRow);
                tableRow.showEditLayout = () => {
                    const textbox = tableRow.findComponentById("textboxIdProfile") as Textbox;
                    const table = this.findComponentById("tableProfiles") as Table;
                    const errorMessage = "A profile with this ID already exists. Please enter a unique ID.";

                    // Perform validation before allowing the slideout to open
                    if (!StringUtil.isEmptyString(textbox.text)) {
                        const duplicateExists = table.rows.some((row: TableRow) => {
                            return row !== tableRow && row.data.get("id")?.toLowerCase() === textbox.text.toLowerCase();
                        });
                        if (duplicateExists) {
                            Snackbar.showWarningSnackbar(errorMessage);
                            textbox.text = "";
                            textbox.focus();
                            return; // Prevent the slideout from opening
                        }
                    }

                    // If validation passes, proceed with the original slideout behavior
                    originalShowEditLayout();
                };
            }
        });
    }

    textboxIdOnBlur(event: BlurEvent){
        const textbox = event.target as Textbox;
        const table = this.findComponentById("tableFreightMatchingUsers") as Table;
        const errorMessage = "The Freight Matching User ID already exists. Please enter a unique ID.";
        if(event.changedWhileFocused && !StringUtil.isEmptyString(textbox.text)){
            this.checkForDuplicatedRows(textbox, table, errorMessage);
        }

    }

    textboxIdProfileOnBlur(event: BlurEvent){
        const textbox = event.target as Textbox;
        const table = this.findComponentById("tableProfiles") as Table;
        const errorMessage = "A profile with this ID already exists. Please enter a unique ID.";
        if(event.changedWhileFocused && !StringUtil.isEmptyString(textbox.text)){
            this.checkForDuplicatedRows(textbox, table, errorMessage);
        }
    }

    checkForDuplicatedRows(textbox: Textbox,table: Table, errorMessage: string){
         const tableRow = TableRow.getContainingTableRow(textbox);
            const inputId = textbox.text.toLowerCase();
            const duplicateExists = table.rows.some((row: TableRow) => {
                return row !== tableRow && row.data.get("id")?.toLowerCase() === inputId;
            });
            if (duplicateExists) {
                Snackbar.showWarningSnackbar(errorMessage);
                textbox.text = "";
                textbox.focus();
            }

    }

    async postDataSources(vendorId?: string) {
        try {
            await this.mainDataSource.post();
            return true;
        } catch (error) {
            CommonDialogs.showError("Error posting FM control datasource:", error);
            return false;
        }
    }
}
